/* holo-perf.js (Live jank fix TEST, Oct 12 2026). Same look, less work:
   the glow-ring colour cycle (--holo-r1/--holo-r2) runs on each glowing element instead of on <html>
   (a change on <html> restyled the whole page), all in sync, paused while off screen. Roll back: remove this file + its tag in holo-head. */
(function () {
  var d = document.documentElement;
  if (!d.classList.contains('holo-on') || d.getAttribute('data-holo-imgglow') !== 'true' || !Element.prototype.animate || !window.CSS || !CSS.registerProperty && !CSS.supports('color', 'var(--x)')) return;
  if (d.classList.contains('holo-lite') || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var speed = parseFloat(getComputedStyle(d).getPropertyValue('--holo-speed')) || 1;
  var small = matchMedia('(max-width: 749px)').matches;
  var DUR = 48000 * speed, E = 'steps(' + (small ? 24 : 60) + ')';
  var K1 = [{ '--holo-r1': '#4df5e8', easing: E }, { '--holo-r1': '#8fb8ff', easing: E }, { '--holo-r1': '#4df5e8' }];
  var K2 = [{ '--holo-r2': '#a47cff', easing: E }, { '--holo-r2': '#d58cff', easing: E }, { '--holo-r2': '#a47cff' }];
  function splitTop(sel) { var out = [], depth = 0, cur = ''; for (var i = 0; i < sel.length; i++) { var c = sel[i]; if (c === '(') depth++; else if (c === ')') depth--; if (c === ',' && !depth) { out.push(cur.trim()); cur = ''; } else cur += c; } if (cur.trim()) out.push(cur.trim()); return out; }
  var targets = [];
  function collect(rules) {
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.cssRules && !r.selectorText) { try { if (!r.media || matchMedia(r.media.mediaText).matches) collect(r.cssRules); } catch (e) {} continue; }
      if (!r.selectorText || !r.style || r.cssText.indexOf('var(--holo-r') < 0) continue;
      splitTop(r.selectorText).forEach(function (s) {
        if (/:(hover|focus|active)/.test(s)) s = s.replace(/:(hover|focus-visible|focus-within|focus|active)/g, '');
        var m = s.match(/::?(before|after)\s*$/), pseudo = m ? '::' + m[1] : null;
        if (m) s = s.slice(0, m.index);
        if (!s.trim() || /^html[^ ]*$/.test(s.trim())) return;
        targets.push([s, pseudo]);
      });
    }
  }
  // SPEEDMAX1730 FIX1: same rule list, precomputed per CSS file version (snippets/holo-perf-targets.liquid), so no page load has to
  // serialise every CSS rule. A sheet without an entry (changed ?v=) is scanned exactly as before.
  function addRule(sel) {
    splitTop(sel).forEach(function (s) {
      if (/:(hover|focus|active)/.test(s)) s = s.replace(/:(hover|focus-visible|focus-within|focus|active)/g, '');
      var m = s.match(/::?(before|after)\s*$/), pseudo = m ? '::' + m[1] : null;
      if (m) s = s.slice(0, m.index);
      if (!s.trim() || /^html[^ ]*$/.test(s.trim())) return;
      targets.push([s, pseudo]);
    });
  }
  var PRE = window.__hpT || {};
  for (var i = 0; i < document.styleSheets.length; i++) {
    var ss = document.styleSheets[i]; if (!ss.href || ss.href.indexOf('holo-') < 0) continue;
    var pre = PRE[ss.href.split('/assets/').pop()];
    if (pre) { pre.forEach(function (x) { try { for (var k = 0; k < x[1].length; k++) if (!matchMedia(x[1][k]).matches) return; } catch (e) { return; } addRule(x[0]); }); continue; }
    try { collect(ss.cssRules); } catch (e) {}
  }
  if (!targets.length) return;
  // r12 perf: same colours at the same step times, but set only when a step actually changes (every DUR/2/steps ms)
  // instead of a Web Animation that Chrome re-samples on every frame. Stays in sync with the old timeline (origin 0).
  var STEPS = small ? 24 : 60, HALF = DUR / 2, STEP = HALF / STEPS;
  function hex(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
  var C1 = [hex('#4df5e8'), hex('#8fb8ff')], C2 = [hex('#a47cff'), hex('#d58cff')];
  function mix(c, f) { return 'rgb(' + Math.round(c[0][0] + (c[1][0] - c[0][0]) * f) + ', ' + Math.round(c[0][1] + (c[1][1] - c[0][1]) * f) + ', ' + Math.round(c[0][2] + (c[1][2] - c[0][2]) * f) + ')'; }
  function vals(t) { var ph = t % DUR, seg = ph < HALF ? 0 : 1, k = Math.floor((ph - seg * HALF) / STEP) / STEPS, f = seg ? 1 - k : k; return [mix(C1, f), mix(C2, f)]; }
  var done = new WeakMap(), vis = new Set(), cur = null;
  // pseudo-element targets inherit the custom property from their element, so setting it on the element is equivalent.
  function setOn(el) { el.style.setProperty('--holo-r1', cur[0]); el.style.setProperty('--holo-r2', cur[1]); }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { vis.add(e.target); if (cur) setOn(e.target); } else vis.delete(e.target); });
  }, { rootMargin: '150px 0px' });
  function tick() {
    var t = document.timeline ? document.timeline.currentTime : performance.now();
    cur = vals(t); if (!document.hidden) vis.forEach(setOn);
    setTimeout(tick, STEP - (t % STEP) + 2);
  }
  function apply() {
    targets.forEach(function (t) {
      var els; try { els = document.querySelectorAll(t[0]); } catch (e) { return; }
      els.forEach(function (el) { if (done.has(el)) return; done.set(el, 1); io.observe(el); });
    });
    if (!apply.on) { apply.on = 1; tick(); }
  }
  // r12 perf: the stepped effects (baked 24 steps/s sweeps/shimmers/sheens, pz-ang 21 steps/s) only change frame 21-24x a second,
  // but Chrome re-samples them on every frame. Drive them from a timer at their own step rate instead: same frames, same timing.
  var RATE = { 'holo-sweep': 24, 'holo-shimmer': 24, 'pz-title': 24, 'hb-sheen': 24, 'pz-ang': 21 }, stepped = new Map();
  function off(el) { return d.classList.contains('hp-hidden') || document.hidden || (el && el.closest && el.closest('.hp-off,.holo-paused')); }
  function scan() {
    var live = new Set();
    document.getAnimations().forEach(function (a) {
      var r = RATE[a.animationName]; if (!r) return; live.add(a);
      if (stepped.has(a) || a.playState !== 'running') return;
      var lt = a.currentTime || 0; a.pause(); stepped.set(a, { lt: lt, r: r, i: -1, el: a.effect && a.effect.target });
    });
    stepped.forEach(function (e, a) { if (!live.has(a)) stepped.delete(a); });
  }
  function stepLoop(r) {
    var last = performance.now();
    (function t() {
      var now = performance.now(), dt = now - last; last = now;
      stepped.forEach(function (e, a) {
        if (a.playState === 'idle') { stepped.delete(a); return; } // SPEEDMAX1730 FIX2: cancelled (class removed) -> forget it, never revive it
        if (e.r !== r || off(e.el)) return;
        e.lt += dt; var i = Math.floor(e.lt * r / 1000);
        if (i !== e.i) { e.i = i; a.currentTime = e.lt; }
      });
      setTimeout(t, 1000 / r);
    })();
  }
  // SPEEDMAX1730 FIX2: document.getAnimations() forces a whole-page style update; it ran every 2 s. New stepped animations are now picked up
  // from their animationstart event (only that element is asked), with a slow 10 s safety scan. The keyframes are pre-sampled step-end,
  // so a frame driven natively or by the stepper is the same frame: nothing can look different.
  function adopt(el, name) {
    var list; try { list = el.getAnimations({ subtree: true }); } catch (e) { return; }
    list.forEach(function (a) {
      if (a.animationName !== name || stepped.has(a) || a.playState !== 'running') return;
      var lt = a.currentTime || 0; a.pause(); stepped.set(a, { lt: lt, r: RATE[name], i: -1, el: a.effect && a.effect.target });
    });
  }
  function startSteps() {
    if (!document.getAnimations) return; scan(); setInterval(scan, 10000); stepLoop(24); stepLoop(21);
    document.addEventListener('animationstart', function (e) { if (RATE[e.animationName] && e.target && e.target.getAnimations) adopt(e.target, e.animationName); }, true);
  }
  // round 2: start the per-element colour cycle only once the page is loaded and idle (html.hp-ready), not during first paint.
  // Until then every ring shows the first keyframe colour, which is the same colour it starts on anyway.
  function go() {
    if (go.done) return; go.done = 1;
    apply();
    d.classList.add('hp-r');
    startSteps();
    setTimeout(apply, 3000); setTimeout(apply, 8000);
  }
  if (d.classList.contains('hp-ready')) go();
  else { new MutationObserver(function (m, o) { if (d.classList.contains('hp-ready')) { o.disconnect(); go(); } }).observe(d, { attributes: true, attributeFilter: ['class'] }); setTimeout(go, 6000); }
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('visibilitychange', function () { if (!document.hidden && cur) vis.forEach(setOn); });
})();
